import clsx from "clsx"
import { useMemo, useState } from "react"
import { TabContent, TabPane } from "reactstrap"
import TabPanel from "./TabPanel"

export default function TabView({ children, defaultTab, onTabChange }) {
  const [tab, setTab] = useState(defaultTab)

  const handleTab = (id, disabled) => e => {
    e.preventDefault()
    if (disabled)
      return
    const actualTab = tab
    setTab(id)
    onTabChange && onTabChange(id, () => {
      setTab(actualTab)
    })
  }

  const lst = useMemo(() => {
    if (Array.isArray(children))
      return children
        .filter(el => !!el)
        .map((el, idx) => (
          { id: (el.props.id || idx + 1), label: el.props.label, children: el.props.children, disabled: el.props.disabled || false }
        ))
    else
      return [{ id: (children.props.label || 1), label: children.props.label, children: children.children, disabled: children.disabled || false }]
  }, [children])


  return (
    <>
      <ul className="nav nav-tabs">
        {lst.map(el => (
          <li className="nav-item" key={el.id}>
            <a
              className={clsx("nav-link", { 'active': (tab || lst[0].id) == el.id })}
              style={el.disabled ? { color: '#ccc', cursor: 'auto' } : {}}
              href="#" 
              onClick={handleTab(el.id, el.disabled)}
            >{el.label}</a>
          </li>
        ))}
      </ul>
      <TabContent activeTab={"tab" + (tab || lst[0].id)}>
        {lst.map(el => (
          <TabPane key={el.id} tabId={"tab" + el.id.toString()}>{el.children}</TabPane>
        ))}
      </TabContent>
    </>
  )
}